import React, {
  useContext,
  useRef,
  useState,
  useEffect,
} from 'react';
import { useQuery } from '@apollo/client';
import {
  faCheck,
  faEdit,
  faPaperclip,
  faDownload,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import {
  QuantaFormik,
  QuantaForm,
  useQuantaFormikContext,
  useResponsiveParams,
  MixedGridGroup,
  QuantaRadioGroup,
  Text,
  Grid,
  GridItem,
  QuantaSelect,
  QuantaInput,
  Paper,
  Button,
} from 'quanta-ui';
// import { ConfigContext } from '../../../../../lib/config/ConfigProvider';

import { QuantaConfigContext } from 'quanta-flows';
// import useMutationQuery from '../../../../../lib/graphql/useMutationQuery';
import { useMutationQuery } from 'quanta-flows';
// import { Error, Loading } from '../../../../../lib/layout';
import { Error, Loading } from 'quanta-flows/modules/layout';
import {
  GET_CUSTOMER_TYPE_DOMAIN,
  GET_DATE_TIME,
  GET_DEFAULT_CLAUSES,
  GET_DEFAULT_CONDITIONS,
  GET_DEFAULT_EXCLUSIONS,
  GET_DEFAULT_WARRANTIES,
  PROPOSAL_PAYMENT_TYPE_LIST,
  DOCUMENT_STATIC_DATA,
  GET_DOCUMENTS_INFO,
  //GET_BUY_FIRE_POLICY_VAR_DETAILS,
  SAVE_PROPOSAL_FIRE,
  GET_BUY_FIRE_UPLOAD_POLICY_VAR_DETAILS,
  PROFILE_DETAILS
} from '../queries';
import { GET_BUY_FIRE_POLICY_VAR_DETAILS } from 'quanta-flows/modules/proposal/fire';
//import { updateBuyFirePolicyVar } from '../_graphql/state';
import { updateBuyFirePolicyVar } from 'quanta-flows/modules/proposal/fire/state';
// import ProposerCustomerReadOnly from '../../../../common/proposer-customer/proposer-customer-readonly';
import { ProposerCustomerReadOnly } from 'quanta-flows/modules/common/proposer/edit';
// import useFetchQuery from '../../../../../lib/graphql/useFetchQuery';
import { useFetchQuery } from 'quanta-flows';
import RiskDetailsData from './risk-details-data';

export default function ReviewAndConfirmDetailsFire({
  goToStep,
  proceedToNextStep,
  setProceedToNextStep,
  currentStepFunctions,
  setCurrentStepFunctions,
  setParentAlerts,
  setLoadingStep,
  setCustomLoadingMessage,
  productCode,
  lobCode,
  lobName,
  productName,
  renderExpandedCards,
  ...props
}) {
  const initLoadRef = useRef([]);
  const fetchQuery = useFetchQuery();
  const mutateQuery = useMutationQuery();
  const [
    customerDocumentListAuto,
    setCustomerDocumentListAuto,
  ] = useState(null);
  const { branding } = useContext( QuantaConfigContext);

  useEffect(() => {
    let isMounted = true;
    const getCustomerDocumentInfo = async () => {
      const documentsInfoQuery = fetchQuery({
        query: GET_DOCUMENTS_INFO,
      });
      const { data: documentsData } = await documentsInfoQuery;
      setCustomerDocumentListAuto(documentsData?.documentList);
    };
    if (isMounted) {
      getCustomerDocumentInfo();
    }
    return () => {
      isMounted = false;
    };
  });

  const {
    loading: loadingDocumentExtensions,
    error: errorDocumentExtensions,
    data: dataDocumentExtensions,
  } = useQuery(DOCUMENT_STATIC_DATA, {
    fetchPolicy: 'cache-first',
  });

  const {
    loading: loadingPaymentType,
    error: errorPaymentType,
    data: dataPaymentType,
  } = useQuery(PROPOSAL_PAYMENT_TYPE_LIST, {
    fetchPolicy: 'cache-first',
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 1];
    },
  });

  const {
    loading: loadingBuyPolicy,
    error: errorBuyPolicy,
    data: dataBuyPolicy,
    previousData,
  } = useQuery(GET_BUY_FIRE_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first',
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 2];
    },
  });
  const {
    loading: loadingDateTime,
    error: errorDateTime,
    data: dataDateTime,
  } = useQuery(GET_DATE_TIME, {
    fetchPolicy: 'network-only',
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 3];
    },
  });

  const {
    loading: loadingUploadDocsVar,
    error: errorUploadDocsVar,
    data: dataUploadDocsVar,
  } = useQuery(GET_BUY_FIRE_UPLOAD_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first',
  });

  const {
    loading: loadingDefaultWarranties,
    error: errorDefaultWarranties,
    data: dataDefaultWarranties,
  } = useQuery(GET_DEFAULT_WARRANTIES, {
    fetchPolicy: 'cache-first',
    variables: {
      input: {
        productCode,
        populateType: '4',
      },
    },
  });

  const {
    loading: loadingDefaultClauses,
    error: errorDefaultClauses,
    data: dataDefaultClauses,
  } = useQuery(GET_DEFAULT_CLAUSES, {
    fetchPolicy: 'cache-first',
    variables: {
      input: {
        productCode,
        populateType: '1',
      },
    },
  });

  const {
    loading: loadingDefaultConditions,
    error: errorDefaultConditions,
    data: dataDefaultConditions,
  } = useQuery(GET_DEFAULT_CONDITIONS, {
    fetchPolicy: 'cache-first',
    variables: {
      input: {
        productCode,
        populateType: '2',
      },
    },
  });

  const {
    loading: loadingDefaultExclusions,
    error: errorDefaultExclusions,
    data: dataDefaultExclusions,
  } = useQuery(GET_DEFAULT_EXCLUSIONS, {
    fetchPolicy: 'cache-first',
    variables: {
      input: {
        productCode,
        populateType: '3',
      },
    },
  });
  const {
    loading: loadingProfile,
    error: loadingError,
    data: dataProfileData,
  } = useQuery(PROFILE_DETAILS, {
    fetchPolicy: 'network-only',

  });
  if (
    loadingPaymentType ||
    loadingBuyPolicy ||
    loadingDateTime ||
    loadingUploadDocsVar ||
    loadingDefaultWarranties ||
    loadingDefaultClauses ||
    loadingDefaultConditions ||
    loadingDefaultExclusions||
    loadingProfile
  ) {
    return (
      <div className="min-h-screen">
        <Loading />
      </div>
    );
  }
  if (
    errorPaymentType ||
    errorBuyPolicy ||
    errorDateTime ||
    errorUploadDocsVar ||
    errorDefaultWarranties ||
    errorDefaultClauses ||
    errorDefaultConditions ||
    errorDefaultExclusions
  ) {
    return (
      <div className="min-h-screen">
        <Error
          error={
            errorPaymentType ||
            errorBuyPolicy ||
            errorDateTime ||
            errorUploadDocsVar ||
            errorDefaultWarranties ||
            errorDefaultClauses ||
            errorDefaultConditions ||
            errorDefaultExclusions
          }
        />
      </div>
    );
  }

  if (dataBuyPolicy) {
    var { buyFirePolicy } = dataBuyPolicy;
  }
  if (dataUploadDocsVar) {
    var { fireQuoteUploadDocs } = dataUploadDocsVar;
  }

  const { ProposalPaymentTypeList } = dataPaymentType;

  const { datetimeValue } = dataDateTime
    ? dataDateTime
    : { time: null, date: buyFirePolicy?.policy?.date };

  const { getDefaultWarranties } = dataDefaultWarranties;
  const { getDefaultClauses } = dataDefaultClauses;
  const { getDefaultConditions } = dataDefaultConditions;
  const { getDefaultExclusions } = dataDefaultExclusions;
  const obj = { dataProfileData };
  const value = Object.values(obj);
 
  const mapUserId = value?.[0]?.userMyDetail?.userId;
  const validate = (values) => {
    const errors = {};
    let errorCount = 0;
    errors.documentDetails = values?.documentDetails?.map((_) => {
      return {};
    });

    for (let i = 0; i < values?.documentDetails?.length; i++) {
      if (
        !values?.documentDetails[i]?.documentName &&
        values?.documentDetails[i]?.documentSize
      ) {
        errors.documentDetails[i].documentName = '* Required';
        errorCount += 1;
      }
      if (
        !values?.documentDetails[i]?.documentName &&
        values?.documentDetails[i]?.documentDescription
      ) {
        errors.documentDetails[i].documentName = '* Required';
        errors.documentDetails[i].documentDescription =
          '* Document Type Not Selected';
        errorCount += 1;
      }
      if (
        values?.documentDetails[i]?.documentNameValue
          ?.toString()
          ?.toLowerCase()
          ?.trim() === 'others' &&
        !values?.documentDetails[i]?.documentDescription
      ) {
        errors.documentDetails[i].documentDescription = '* Required';
        errorCount += 1;
      }
      if (
        values?.documentDetails[i]?.documentDescription &&
        !values?.documentDetails[i]?.documentDescription?.match(
          /^[a-zA-Z ]*$/,
        )
      ) {
        errors.documentDetails[
          i
        ].documentDescription = `* Can only contain alphabets`;
        errorCount += 1;
      }
      if (
        values?.documentDetails[i]?.documentDescription &&
        values?.documentDetails[i]?.documentDescription?.length >
          parseInt(docDescCharacterLimit?.code)
      ) {
        errors.documentDetails[
          i
        ].documentDescription = `* Can be of maximum ${docDescCharacterLimit?.value} characters`;
        errorCount += 1;
      }
      if (
        (values?.documentDetails[i]?.documentName ||
          values?.documentDetails[i]?.documentDescription) &&
        !values?.documentDetails[i]?.documentFileName
      ) {
        errors.documentDetails[
          i
        ].documentFileName = `* Input file not provided`;
        errorCount += 1;
      }
      if (
        (values?.documentDetails[i]?.documentName ||
          values?.documentDetails[i]?.documentDescription) &&
        !values?.documentDetails[i]?.documentSize
      ) {
        errors.documentDetails[
          i
        ].documentSize = `* File size details is unknown`;
        errorCount += 1;
      }
    }
    if (errorCount > 0) {
      return errors;
    }

    return {};
  };

  const getDomainData = (
    domainArr,
    searchText,
    searchType,
    returnType,
  ) => {
    return domainArr.find(
      (d) =>
        d[`${searchType}`]?.toLowerCase() ===
        searchText?.toLowerCase(),
    )
      ? domainArr.find(
          (d) =>
            d[`${searchType}`]?.toLowerCase() ===
            searchText?.toLowerCase(),
        )[`${returnType}`]
      : '';
  };

  const initialValues = {
    isProposalCreated:
      buyFirePolicy?.proposalNumber?.length > 0 ? true : false,
    proposalPaymentType: buyFirePolicy?.reviewAndConfirmTabDetails
      ?.proposalPaymentType
      ? `${buyFirePolicy?.reviewAndConfirmTabDetails?.proposalPaymentType}`
      : ProposalPaymentTypeList && ProposalPaymentTypeList?.length > 0
      ? ProposalPaymentTypeList[0]?.code
      : '',
    documentDetails:
      buyFirePolicy?.reviewAndConfirmTabDetails?.documentDetails
        ?.length === 0
        ? [
            {
              documentDescription: '',
              documentName: '',
              documentNameValue: '',
              documentFileName: '',
              documentFileNameWithExtension: '',
              documentExtension: '',
              documentSize: null,
              documentSizeinKB: '',
              dragging: false,
              dragCounter: 0,
              documentBase64String: '',
            },
          ]
        : buyFirePolicy?.reviewAndConfirmTabDetails?.documentDetails?.map(
            (documentDetails) => {
              return {
                ...documentDetails,
              };
            },
          ),
  };

  const getSaveProposalMutationVariables = (
    buyFirePolicy,
    getDateTimeData,
    values,
  ) => {
    return {
      input: {
        eqZone: buyFirePolicy?.quoteData?.eqZone,
        district:buyFirePolicy?.quoteData?.district,
          locationCode: buyFirePolicy?.quoteData?.locationCode,
          pinCodeLocality: buyFirePolicy?.quoteData?.pinCodeLocality,
          city: buyFirePolicy?.quoteData?.city,
        Locationpin:buyFirePolicy?.quoteData?.pincode,
        LocationState: buyFirePolicy?.quoteData?.state,
        intermediary: {
          intermediaryCode: buyFirePolicy?.intermediary?.code,
          locationCode: buyFirePolicy?.intermediary?.branchOfficeCode,
          fieldUserCode: buyFirePolicy?.intermediary?.fieldUserCode
            ? buyFirePolicy?.intermediary?.fieldUserCode
            : buyFirePolicy?.quoteData?.intermediaryDetails?.fieldUserCode
        },
        lob: lobCode,
        product: productCode,
        UserId:mapUserId?mapUserId:'',
        ratePerMillie: buyFirePolicy?.ratePerMillie?.toString(),
        addOnCoversRate: buyFirePolicy?.addOnCoversRate?.toString(),
        stfiCoverRate: buyFirePolicy?.stfiCoverRate?.toString(),
        earthquakeRate: buyFirePolicy?.earthquakeRate?.toString(),
        rsmdCoverRate: buyFirePolicy?.rsmdCoverRate?.toString(),
        terrorismCoverRate: buyFirePolicy?.terrorismCoverRate?.toString(),
        lossMinAndTenantsRate: buyFirePolicy?.lossMinAndTenantsRate?.toString(),
        basement: buyFirePolicy?.riskDetails?.basement?.toString(),
        floornumber: buyFirePolicy?.riskDetails?.floornumber,
        FireCustomerType:buyFirePolicy?.quoteData?.customerDetails?.customerType?.value,
        hometype: buyFirePolicy?.riskDetails?.hometype,
        buildingage: buyFirePolicy?.riskDetails?.buildingage,
        walls: buyFirePolicy?.riskDetails?.walls,
        floor: buyFirePolicy?.riskDetails?.floor,
        roof: buyFirePolicy?.riskDetails?.roof,
        BasisOfSI:buyFirePolicy?.quoteData?.basisOfValuation
        ? buyFirePolicy?.quoteData?.basisOfValuation
        :'',
        typeOfConstruction: buyFirePolicy?.riskDetails?.typeOfConstruction
          ? buyFirePolicy?.riskDetails?.typeOfConstruction?.toString()
          : '',
        height_of_the_Building: buyFirePolicy?.riskDetails?.height_of_the_Building
          ? buyFirePolicy?.riskDetails?.height_of_the_Building?.toString()
          : '',
        deductible: buyFirePolicy?.riskDetails?.deductible
          ? buyFirePolicy?.riskDetails?.deductible?.toString()
          : '0',
        construction_Details: buyFirePolicy?.riskDetails?.construction_Details
          ? buyFirePolicy?.riskDetails?.construction_Details?.toString()
          : '',
        Fire_Protection_Type: buyFirePolicy?.riskDetails?.Fire_Protection_Type
          ? buyFirePolicy?.riskDetails?.Fire_Protection_Type?.toString()
          : '',
        PreAcceptance_Inspection: buyFirePolicy?.riskDetails?.PreAcceptance_Inspection
          ? buyFirePolicy?.riskDetails?.PreAcceptance_Inspection?.toString()
          : '',
        PreAcceptance_Inspection_Date: buyFirePolicy?.riskDetails?.PreAcceptance_Inspection_Date
          ? buyFirePolicy?.riskDetails?.PreAcceptance_Inspection_Date?.toString()
          : '',
        Voluntary_Deductible: buyFirePolicy?.riskDetails?.Voluntary_Deductible
          ? buyFirePolicy?.riskDetails?.Voluntary_Deductible?.toString()
          : '',
        Voluntary_Deductible_PCT: buyFirePolicy?.riskDetails?.Voluntary_Deductible_PCT
          ? buyFirePolicy?.riskDetails?.Voluntary_Deductible_PCT?.toString()
          : '',
        Voluntary_Deductible_Amount: buyFirePolicy?.riskDetails?.Voluntary_Deductible_Amount
          ? buyFirePolicy?.riskDetails?.Voluntary_Deductible_Amount?.toString()
          : '',
        customer: {
          id: buyFirePolicy?.proposerDetails?.id,
          customerType: buyFirePolicy?.proposerDetails?.customerType,
          isThinCustomer: false,
          title: buyFirePolicy?.proposerDetails?.title,
          firstName: buyFirePolicy?.proposerDetails?.firstName,
          middleName: buyFirePolicy?.proposerDetails?.middleName,
          lastName: buyFirePolicy?.proposerDetails?.lastName,
          gender: buyFirePolicy?.proposerDetails?.gender,
          proposerDOB: buyFirePolicy?.proposerDetails?.proposerDOB,
          orgName: buyFirePolicy?.proposerDetails?.orgName,
          orgType: buyFirePolicy?.proposerDetails?.orgType,
          contactName: buyFirePolicy?.proposerDetails?.contactName,
          regNumber: buyFirePolicy?.proposerDetails?.regNumber,
          tanNumber: buyFirePolicy?.proposerDetails?.tanNumber,
          gstNumber: buyFirePolicy?.proposerDetails?.gstNumber,
          idProofType: buyFirePolicy?.proposerDetails?.idProofType,
          idProofNumber:
            buyFirePolicy?.proposerDetails?.idProofNumber,
          panNumber: buyFirePolicy?.proposerDetails?.panNumber,
          maritalStatus:
            buyFirePolicy?.proposerDetails?.maritalStatus,
          occupation: buyFirePolicy?.proposerDetails?.occupation,
          nationality: buyFirePolicy?.proposerDetails?.nationality,
          permAddressLine1:
            buyFirePolicy?.proposerDetails?.permAddressLine1,
          permAddressLine2:
            buyFirePolicy?.proposerDetails?.permAddressLine2,
          permAddressLine3:
            buyFirePolicy?.proposerDetails?.permAddressLine3,
          permLandmark: buyFirePolicy?.proposerDetails?.permLandmark,
          permPincode: buyFirePolicy?.proposerDetails?.permPincode,
          permCityTownVillage:
            buyFirePolicy?.proposerDetails?.permCityTownVillage,
          permDistrict: buyFirePolicy?.proposerDetails?.permDistrict,
          permState: buyFirePolicy?.proposerDetails?.permState,
          permCommAddressYN: buyFirePolicy?.proposerDetails
            ?.permCommAddressYN
            ? true
            : false,
          commAddressLine1:
            buyFirePolicy?.proposerDetails?.commAddressLine1,
          commAddressLine2:
            buyFirePolicy?.proposerDetails?.commAddressLine2,
          commAddressLine3:
            buyFirePolicy?.proposerDetails?.commAddressLine3,
          commLandmark: buyFirePolicy?.proposerDetails?.commLandmark,
          commPincode: buyFirePolicy?.proposerDetails?.commPincode,
          commCityTownVillage:
            buyFirePolicy?.proposerDetails?.commCityTownVillage,
          commDistrict: buyFirePolicy?.proposerDetails?.commDistrict,
          commState: buyFirePolicy?.proposerDetails?.commState,
          phoneNo: buyFirePolicy?.proposerDetails?.phoneNo,
          mobileNo: buyFirePolicy?.proposerDetails?.mobileNo,
          emailID: buyFirePolicy?.proposerDetails?.emailID,
          faxNo: buyFirePolicy?.proposerDetails?.faxNo,
          altPhoneNo: buyFirePolicy?.proposerDetails?.altPhoneNo,
          altMobileNo: buyFirePolicy?.proposerDetails?.altMobileNo,
          ifscCode: buyFirePolicy?.proposerDetailsMeta?.ifscCode,
          bankName: buyFirePolicy?.proposerDetailsMeta?.bankName,
          branchName: buyFirePolicy?.proposerDetailsMeta?.branchName,
          bankAcno: buyFirePolicy?.proposerDetailsMeta?.bankAcno,
          accountHolderName:
            buyFirePolicy?.proposerDetailsMeta?.accountHolderName,
          micrCode: buyFirePolicy?.proposerDetailsMeta?.micrCode,
          employeeNumber: buyFirePolicy?.proposerDetails
            ?.employeeNumber
            ? buyFirePolicy?.proposerDetails?.employeeNumber
            : '',

          agentID: buyFirePolicy?.proposerDetails?.agentID
            ? buyFirePolicy?.proposerDetails?.agentID
            : '',
          /**SADivya : CR498 : PAN Mandatory */
          form60: buyFirePolicy?.proposerDetails?.form60?.toString()?.toLowerCase() === 'true'
            ? true : false,
          dateOfIncorporation: buyFirePolicy?.proposerDetails?.dateOfIncorporation,
          /**EADivya : CR498 : PAN Mandatory */
        },
        businessOfInsured: buyFirePolicy?.businessOfInsured,
        anyPrevClaimsExp: buyFirePolicy?.anyPrevClaimsExp,
        prevClaimExpDesc: buyFirePolicy?.prevClaimExpDesc,
        isKutchaConstruct: buyFirePolicy?.isKutchaConstruct,
        policyType: buyFirePolicy?.policyType,
        quoteNumber: buyFirePolicy?.quoteNumber,
        tenure: buyFirePolicy?.quoteData.tabDetails.customerTabDetails.policyTypeDetails.tenure.code,
        policyStartDate: buyFirePolicy?.riskDetails?.policyStartDate
        ? buyFirePolicy?.riskDetails?.policyStartDate
        : getDateTimeData?.datetimeValue?.date,
        policyTime:moment().format("HH:mm")?.toString(), //'00:00',
        riskCovers:buyFirePolicy?.quoteData?.riskcoverdata,
        riskLocations:
          buyFirePolicy?.policyTypeValue
            ?.toString()
            ?.toLowerCase() === 'floater'
            ? {
                quoteNumber: buyFirePolicy?.quoteNumber,
                riskLocationID:
                  buyFirePolicy?.quoteData?.tabDetails
                    ?.riskLocationTabDetails?.floaterType
                    ?.riskLocationID,
                occupancyCodeValue: {
                  code:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType?.occupancy
                      ?.code,
                  value:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType?.occupancy
                      ?.value,
                  occupancySection:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType?.occupancy
                      ?.occupancySection,
                  occupancyRate:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType?.occupancy
                      ?.occupancyRate,
                  riskCode:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType?.occupancy
                      ?.riskCode,
                  rateCode:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType?.occupancy
                      ?.rateCode,
                  riskGrade:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType?.occupancy
                      ?.riskGrade,
                  riskGradeDefinition:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType?.occupancy
                      ?.riskGradeDefinition,
                  riskPreference:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType?.occupancy
                      ?.riskPreference,
                  gicClass:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType?.occupancy
                      ?.gicClass,
                  stfiRate:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType?.occupancy
                      ?.stfiRate,
                  rsmdRate:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType?.occupancy
                      ?.rsmdRate,
                },
                riskLocAddress: {
                  addressLine1: '',
                  addressLine2: '',
                  addressLine3: '',
                  landmark: '',
                  pinCode: '',
                  state: '',
                  city: '',
                  district: '',
                  zone: '',
                  eqZone: '',
                  locationCode: '',
                  isSamePremises: false,
                  allIndiaBasisDesc: '',
                },

                floaterLocations: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.floaterType?.floaterLocations?.map(
                  (fire) => {
                    return {
                      addressLine1: fire?.addressLine1,
                      addressLine2: fire?.addressLine2
                        ? fire?.addressLine2
                        : '',
                      addressLine3: fire?.addressLine3
                        ? fire?.addressLine3
                        : '',
                      landmark: '',
                      pinCode: fire?.pinCode ? fire?.pinCode : '',
                      state: fire?.state ? fire?.state : '',
                      city: fire?.city ? fire?.city : '',
                      district: fire?.district ? fire?.district : '',
                      zone: fire?.zone ? fire?.zone : '',
                      eqZone: fire?.eqZone ? fire?.eqZone : '',
                      locationCode: fire?.locationCode
                        ? fire?.locationCode
                        : '',
                      isSamePremises:
                        fire?.isSamePremises === true ? true : false,
                      allIndiaBasisDesc: fire?.isSamePremises
                        ? fire?.isSamePremises
                        : '',
                    };
                  },
                ),

                buildingSI: '',
                plantMachinerySI: '',
                furnitureFixtureSI: '',
                rawMaterialSI: '',
                otherContentsSI: '',
                stocksSI:
                  buyFirePolicy?.quoteData?.tabDetails
                    ?.riskLocationTabDetails?.floaterType
                    ?.riskSumInsured?.stocksSI,

                stocksInProcessSI:
                  buyFirePolicy?.quoteData?.tabDetails
                    ?.riskLocationTabDetails?.floaterType
                    ?.riskSumInsured?.stocksInProcessSI,

                fireExtinguishApplisDtls: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.floaterType?.fireExtinguisherAppliancesDetails?.map(
                  (fire) => {
                    return {
                      applianceCode: fire?.value,
                      isSelected: fire?.selected,
                    };
                  },
                ),
                constructionClass:
                  buyFirePolicy?.quoteData?.tabDetails
                    ?.riskLocationTabDetails?.floaterType
                    ?.otherDetails?.classOfConstruction,

                waterbodyDistance:
                  buyFirePolicy?.quoteData?.tabDetails
                    ?.riskLocationTabDetails?.floaterType
                    ?.otherDetails?.distanceFromWaterbody,

                securityProvisions:
                  buyFirePolicy?.quoteData?.tabDetails
                    ?.riskLocationTabDetails?.floaterType
                    ?.otherDetails?.securityProvisions,

                loadingPct:
                  buyFirePolicy?.quoteData?.tabDetails
                    ?.riskLocationTabDetails?.floaterType
                    ?.loadingAndDiscount?.loadingPercentage,
                discountPct:
                  buyFirePolicy?.quoteData?.tabDetails
                    ?.riskLocationTabDetails?.floaterType
                    ?.loadingAndDiscount?.discountPercentage,
                prevClaimExpDesc:
                  buyFirePolicy?.quoteData?.tabDetails
                    ?.riskLocationTabDetails?.floaterType
                    ?.previousClaimDetails?.claimExperience,

                premium: {
                  locNetPremium:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType
                      ?.locationPremium?.locationNetPremium,
                  locGST:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType
                      ?.locationPremium?.locationGST,
                  locTotalPremium:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType
                      ?.locationPremium?.locationTotalPremium,
                  stampDuty:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType
                      ?.locationPremium?.stampDuty,
                  basicRate:buyFirePolicy?.quoteData?.tabDetails
                    ?.riskLocationTabDetails?.floaterType
                    ?.locationPremium?.basicRate,
                },
              }
            : buyFirePolicy?.policyTypeValue
                ?.toString().includes('Home') 
                //=== 'Home Building And Home Contents'
            ?[ {
                    quoteNumber: buyFirePolicy?.quoteNumber,
                    riskLocationID: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskLocationID,
                ratePerMille: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.ratePerMille,

                    occupancyCodeValue: {
                      code: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.occupancy?.code,
                      value: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.occupancy?.value,
                      occupancySection:
                        buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.occupancy?.occupancySection,
                      occupancyRate:
                        buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.occupancy?.occupancyRate,
                      riskCode: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.occupancy?.riskCode,
                      rateCode: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.occupancy?.rateCode,
                      riskGrade: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.occupancy?.riskGrade,
                      riskGradeDefinition:
                        buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.occupancy?.riskGradeDefinition,
                      riskPreference:
                        buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.occupancy?.riskPreference,
                      gicClass: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.occupancy?.gicClass,
                      stfiRate: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.occupancy?.stfiRate,
                      rsmdRate: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.occupancy?.rsmdRate,
                    },
                    riskSumInsured:{
                      policyTypeValue:buyFirePolicy?.policyTypeValue,
                      // additionalStructure: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.additionalStructure,
                      // buildingValue:buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.buildingValue,
                      // carpetArea:buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.carpetArea,
                      // costOfConstruction:buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.costOfConstruction,
                      // totalBuildingSI:buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.totalBuildingSI,
                      costOfConstruction:
            parseFloat(buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.buildingValue) /
            parseFloat(buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.carpetArea),
            carpetArea:
            parseFloat(buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.carpetArea),
            buildingValue:
            parseFloat(buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.buildingValue),
            additionalStructure:
            parseFloat(buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.additionalStructure),
            totalBuildingSI:
            parseFloat(buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.totalBuildingSI
              ),
            generalContentSI:
            parseFloat(buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.generalContentSI),
            additionalContent:buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.additionalContent,

            valuableContent:buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.valuableContent,
            valuableContentSI:
            parseFloat(buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.valuableContentSI),
            totalContentSI:
            parseFloat(buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.totalContentSI),
            totalSumInsured:
            parseFloat(buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.totalSumInsured),
            additionalContentSI:
            parseFloat(buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.additionalContentSI),
                    },
                    riskLocAddress: {
                      addressLine1:buyFirePolicy?.riskDetails?.updateriskaddress
                        ? buyFirePolicy?.riskDetails?.updateriskaddress
                        : buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails?.addressLine1,  
                      addressLine2: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails
                        ?.addressLine2
                        ? buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails?.addressLine2
                        : '',
                      addressLine3: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails
                        ?.addressLine3
                        ? buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails?.addressLine3
                        : '',
                      landmark: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails?.landmark
                        ? buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails?.landmark
                        : '',
                      pinCode: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails?.pinCode
                        ? buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails?.pinCode
                        : '',
                      state: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails?.state
                        ? buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails?.state
                        : '',
                      city: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails?.city
                        ? buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails?.city
                        : '',
                      district: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails?.district
                        ? buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails?.district
                        : '',
                      zone: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails?.zone
                        ? buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails?.zone
                        : '',
                      eqZone: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails?.eqZone
                        ? buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails?.eqZone
                        : '',
                      locationCode: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails
                        ?.locationCode
                        ? buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails?.locationCode
                        : '',
                      isSamePremises:
                        buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails?.isSamePremise ===
                        true
                          ? true
                          : false,
                      allIndiaBasisDesc: '',
                    },
                    buildingSI: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.buildingSI
                      ? buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.buildingSI
                      : '',
                    plantMachinerySI: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured
                      ?.plantAndMachinerySI
                      ? buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.plantAndMachinerySI
                      : '',
                    furnitureFixtureSI: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured
                      ?.furnitureFixtureAndFittingsSI
                      ? buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured
                          ?.furnitureFixtureAndFittingsSI
                      : '',
                    rawMaterialSI: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured
                      ?.rawMaterialSI
                      ? buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.rawMaterialSI
                      : '',
                    otherContentsSI: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured
                      ?.otherContentsSI
                      ? buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.otherContentsSI
                      : '',
                    stocksSI: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.stocksSI,

                    stocksInProcessSI:
                      buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.stocksInProcessSI,

                    fireExtinguishApplisDtls: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.fireExtinguisherAppliancesDetails?.map(
                      (fire) => {
                        return {
                          applianceCode: fire?.value,
                          isSelected: fire?.selected,
                        };
                      },
                    ),
                    constructionClass:
                      buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.otherDetails?.classOfConstruction,

                    waterbodyDistance:
                      buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.otherDetails?.distanceFromWaterbody,

                    securityProvisions:
                      buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.otherDetails?.securityProvisions,

                    loadingPct:
                      buyFirePolicy?.quoteData?.loadingAndDiscount?.loadingPercentage,
                    discountPct:
                      buyFirePolicy?.quoteData?.loadingAndDiscount
                        ?.discountPercentage,
                    prevClaimExpDesc:
                      buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.previousClaimDetails?.claimExperience,

                    premium: {
                      locNetPremium:
                        buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.locationPremium?.locationNetPremium,
                      locGST: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.locationPremium?.locationGST,
                      locTotalPremium:
                        buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.locationPremium
                          ?.locationTotalPremium,
                      stampDuty: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.locationPremium?.stampDuty,
                      basicRate: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.locationPremium?.basicRate 
                      || buyFirePolicy?.quoteData?.finalisedPremium?.basicRate,
                    
                    },
                  }]:null,
                
            
        clauses: {
          default:
            buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
              ?.clauses?.defaultClauses,
          userDefined: buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails?.clauses?.userDefinedClauses
            ?.filter((clause) => clause !== '')
            ?.map((clause) => {
              return clause;
            }),
          ClauseCode: buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
          ?.clauses?.ClauseCode,
          ClauseNumber: buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
          ?.clauses?.ClauseNumber,
          Description:buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
          ?.clauses?.Description,
        },
        warranties: {
          default:
            buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
              ?.warranties?.defaultWarranties,
          userDefined: buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails?.warranties?.userDefinedWarranties
            ?.filter((warranty) => warranty !== '')
            ?.map((warranty) => {
              return warranty;
            }),
          WarrantyCode: buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
          ?.warranties?.WarrantyCode,
          WarrantyNumber: buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
          ?.warranties?.WarrantyNumber,
          Description:buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
          ?.warranties?.Description,
        },
        conditions: {
          default:
            buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
              ?.conditions?.defaultConditions,
          userDefined: buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails?.conditions?.userDefinedConditions
            ?.filter((condition) => condition !== '')
            ?.map((condition) => {
              return condition;
            }),
          ConditionCode: buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
          ?.conditions?.ConditionCode,
          ConditionNumber: buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
          ?.conditions?.ConditionNumber,
          Description:buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
          ?.conditions?.Description,
        },
        exclusions: {
          default:
            buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
              ?.exclusions?.defaultExclusions,
          userDefined: buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails?.exclusions?.userDefinedExclusions
            ?.filter((exclusion) => exclusion !== '')
            ?.map((exclusion) => {
              return exclusion;
            }),
          ExclusionCode: buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
          ?.exclusions?.ExclusionCode,
          ExclusionNumber: buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
          ?.exclusions?.ExclusionNumber,
          Description:buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
          ?.exclusions?.Description,
        },
        finalisedPremium: {
          locNetPremium:
            buyFirePolicy?.quoteData?.finalisedPremium
              ?.locationNetPremium,
          locGST:
            buyFirePolicy?.quoteData?.finalisedPremium?.locationGST,
          locTotalPremium:
            buyFirePolicy?.quoteData?.finalisedPremium
              ?.locationTotalPremium,
          stampDuty:
            buyFirePolicy?.quoteData?.finalisedPremium?.stampDuty,
          basicRate: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.locationPremium?.basicRate 
          || buyFirePolicy?.quoteData?.finalisedPremium?.basicRate,
        },
        financierDtls: {
          financerName:
            
            buyFirePolicy?.financierDetails?.financerName,
          
          financerAddress:
           
            buyFirePolicy?.financierDetails?.financerAddress,
          
          financerAgreementType:
            
            buyFirePolicy?.financierDetails?.financerAgreementType,
          
          loanAccountNumber:
           
            buyFirePolicy?.financierDetails?.loanAccountNumber,
          
          FileNumber:
          
            buyFirePolicy?.financierDetails?.fileNumber
          
        },
        nomineeDetails:buyFirePolicy?.members,
        uploadDocuments:
          fireQuoteUploadDocs?.documentDetails &&
          fireQuoteUploadDocs?.documentDetails?.length > 0
            ? fireQuoteUploadDocs?.documentDetails?.map(
                (uploadDet) => {
                  return {
                    documentType: {
                      code: uploadDet?.documentName,
                      value: uploadDet?.documentNameValue,
                    },
                    documentName:
                      uploadDet?.documentFileNameWithExtension,
                    documentSize: uploadDet?.documentSizeinKB,
                    base64EncodedDoc: uploadDet?.documentBase64String,
                  };
                },
              )
            : [],
      },
    };
  };

  const onSubmit = async (values) => {
    if (!buyFirePolicy?.proposalNumber) {
      try {
        setParentAlerts([]);
        let getDateTime = fetchQuery({
          query: GET_DATE_TIME,
        });
        let { data: getDateTimeData } = await getDateTime;
        const variables = getSaveProposalMutationVariables(
          buyFirePolicy,
          getDateTimeData,
          values,
        ); const saveProposalMutation = mutateQuery({
          mutation: SAVE_PROPOSAL_FIRE,
          variables,
        });
        window.scrollTo({ top: 0, behavior: 'smooth' });
        // updateBuyFirePolicyVar({
        //   reviewAndConfirmTabDetails: values,
        // });
        setLoadingStep(true);
        setCustomLoadingMessage('Saving Proposal');
        const { data } = await saveProposalMutation;

        setLoadingStep(false);
        setCustomLoadingMessage(null);
        if (data?.saveProposalFire?.warningMsg) {
          setParentAlerts([
            {
              header: 'Proposal Saved Successfully',
              content: (
                <div className="flex flex-col w-full h-full">
                  <Text type="normal">
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="text-success"
                    />{' '}
                    Proposal Number:{' '}
                    {data?.saveProposalFire?.proposalNumber}
                  </Text>
                </div>
              ),
              type: 'success',
              timeout: null,
              disableClose: false,
            },
            {
              content: (
                <Text type="normal">
                  {data?.saveProposalFire?.warningMsg}
                </Text>
              ),
              type: 'warning',
              timeout: null,
              disableClose: false,
            },
          ]);
        } else {
          setParentAlerts([
            {
              header: 'Proposal Saved Successfully',
              id: Date.now(),
              content: (
                <div className="flex flex-col w-full h-full">
                  <Text type="normal">
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="text-success"
                    />{' '}
                    Proposal Number:{' '}
                    {data?.saveProposalFire?.proposalNumber}
                  </Text>
                </div>
              ),
              type: 'success',
              timeout: null,
              disableClose: false,
            },
          ]);
        }
        updateBuyFirePolicyVar({
          reviewAndConfirmTabDetails: {
            ...values,
            isProposalCreated: true,
          },
          proposalNumber: data?.saveProposalFire?.proposalNumber,
          proposalStatus: data?.saveProposalFire?.proposalStatus,
          isProposalApplicableForPayment: true,
          policy: {
            startDate: datetimeValue?.date,
            endDate: data?.saveProposalFire?.proposalEndDate,
            time: datetimeValue?.time,
          },
          proposalPaymentType: values.proposalPaymentType,
          proposerDetails: {
            id: data?.saveProposalFire?.customerID,
          },
        });
        return true;
      } catch (error) {
        setParentAlerts([
          {
            header: 'Error',
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                {error.message}
              </div>
            ),
            type: 'error',
            timeout: null,
            disableClose: false,
          },
        ]);
        setLoadingStep(false);
        return false;
      }
    } else {
      return true;
    }
  };

  const ReviewAndConfirmForm = ({ validate }) => {
    const { values, setFieldValue } = useQuantaFormikContext();
    const uploadDocRef = useRef([]);
    const repeatForDesktop = 3,
      repeatForMobile = 1;
    const repeatForDesktopUpload = 2,
      repeatForMobileUpload = 1;
    const MINOR_THRESHOLD_AGE = 18;

    const repeat = useResponsiveParams({
      for_mobile: repeatForMobile,
      for_desktop: repeatForDesktop,
    });

    const repeatUpload = useResponsiveParams({
      for_mobile: repeatForMobileUpload,
      for_desktop: repeatForDesktopUpload,
    });

    const screenType = useResponsiveParams({
      for_mobile: 'mobile',
      for_desktop: 'desktop',
    });

    const documentList =
      customerDocumentListAuto && customerDocumentListAuto?.length > 0
        ? customerDocumentListAuto
        : [];

    const clickEnabled = !loadingDocumentExtensions;

    const reviewAndConfirmData = [
      {
        title: 'Review Proposal',
        grid_type: 'data',
        grid_data: [
          {
            label: 'Policy Type',
            text: buyFirePolicy?.policyTypeValue
              ? `${buyFirePolicy?.policyTypeValue} Policy`
              : '',
          },
          {
            label: 'Proposal Type',
            colSpan: 1,
            text: (
              <QuantaRadioGroup
                name={'proposalPaymentType'}
                className={'mt-1'}
                disabledGlobal={
                  buyFirePolicy.proposalNumber.length > 0
                }
                data={
                  ProposalPaymentTypeList &&
                  ProposalPaymentTypeList?.length > 0
                    ? ProposalPaymentTypeList?.map(
                        (proposalPaymentType) => {
                          return {
                            label: proposalPaymentType?.value
                              ? proposalPaymentType?.value
                              : '',
                            value: proposalPaymentType?.code
                              ? proposalPaymentType?.code
                              : '',
                          };
                        },
                      )
                    : []
                }
              />
            ),
          },
          {
            label: 'Policy Start Date',
            text: buyFirePolicy?.policy?.startDate
              ? buyFirePolicy?.policy?.startDate
              : datetimeValue?.date
              ? datetimeValue?.date
              : moment(new Date(), 'DD/MM/YYYY'),
          },
        ],
      },
    ];

    const financierDetailsData = [
      {
        grid_type: 'data',
        grid_data: [
          {
            label: 'Financer Name',
            text: buyFirePolicy?.financierDetails?.financerName
              ? buyFirePolicy?.financierDetails?.financerName
              : null,
          },
          {
            label: 'Financer Address',
            text: buyFirePolicy?.financierDetails?.financerAddress
              ? buyFirePolicy?.financierDetails?.financerAddress
              : null,
          },
          {
            label: 'Financer Agreement Type',
            text: buyFirePolicy?.financierDetails
              ?.financerAgreementType
              ? buyFirePolicy?.financierDetails?.financerAgreementType
              : null,
          },

          {
            label: 'Loan Account Number',
            text: buyFirePolicy?.financierDetails?.loanAccountNumber
              ? buyFirePolicy?.financierDetails?.loanAccountNumber
              : null,
          },

          {
            label: 'File Number',
            text: buyFirePolicy?.financierDetails?.fileNumber
              ? buyFirePolicy?.financierDetails?.fileNumber
              : null,
          },
          !buyFirePolicy.proposalNumber
            ? {
                colSpan: repeat,
                className: 'mt-2',
                text: (
                  <Text
                    severity="action"
                    className="hover:underline cursor-pointer"
                    onClick={(_) => {
                      goToStep(1);
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth',
                      });
                    }}
                  >
                    <FontAwesomeIcon icon={faEdit} className="mr-1" />
                    <Text className="font-bold">Edit Details</Text>
                  </Text>
                ),
              }
            : null,
        ].filter((d) => d),
      },
    ].filter((d) => d);

    const documentDetailsData = [
      {
        grid_type: 'data',
        grid_data: [
          {
            label: '',
            colSpan: repeat,
            className: 'my-4',
            text:
              fireQuoteUploadDocs?.documentDetails &&
              fireQuoteUploadDocs?.documentDetails?.length > 0 &&
              fireQuoteUploadDocs?.documentDetails?.filter(
                (docDet) =>
                  docDet?.documentName &&
                  docDet?.documentBase64String,
              )?.length > 0 ? (
                fireQuoteUploadDocs?.documentDetails?.map(
                  (doc, idx) => {
                    return (
                      <div>
                        <Paper
                          key={idx}
                          className={`my-4 ${
                            idx === 0 ? '-mt-1' : ''
                          } bg-white border border-neutral p-4 rounded`}
                        >
                          <Grid
                            repeat={repeat}
                            gap={0}
                            gapX={0}
                            gapY={0}
                          >
                            <GridItem
                              colSpan={
                                screenType
                                  ?.toString()
                                  ?.toLowerCase() === 'mobile'
                                  ? 1
                                  : 2
                              }
                            >
                              <Text>
                                <Text>
                                  <FontAwesomeIcon
                                    icon={faPaperclip}
                                    size="1x"
                                    className="mr-3"
                                  />
                                </Text>
                                <Text
                                  severity={'info'}
                                  className={'font-semibold'}
                                >
                                  {doc?.documentDescription &&
                                  doc?.documentName
                                    ?.toString()
                                    ?.toLowerCase() === 'others'
                                    ? doc?.documentDescription
                                    : doc?.documentName}
                                </Text>
                                <Text
                                  className={'flex flex-col ml-7'}
                                  severity={'neutral-darker'}
                                  type={'label'}
                                >
                                  <Text
                                    className={
                                      'flex items-center flex-wrap'
                                    }
                                  >
                                    <Text type={'label'}>
                                      File Name:&nbsp;
                                    </Text>
                                    <Text
                                      type={'label'}
                                      className={'break-normal'}
                                    >
                                      {
                                        doc?.documentFileNameWithExtension
                                      }
                                    </Text>
                                  </Text>
                                </Text>
                                <Text
                                  className={'flex flex-col ml-7'}
                                  severity={'neutral-darker'}
                                  type={'label'}
                                >
                                  File Size:&nbsp;
                                  {doc?.documentSize} KB
                                </Text>
                              </Text>
                            </GridItem>
                            <GridItem
                              colSpan={
                                screenType
                                  ?.toString()
                                  ?.toLowerCase() === 'mobile'
                                  ? repeat
                                  : 1
                              }
                              className={
                                'flex flex-col justify-center items-center'
                              }
                            >
                              <Text className="flex justify-center items-center">
                                <Button
                                  type={'button'}
                                  flat={true}
                                  className="w-full md:w-56 md:pr-4 max-h-10 -ml-0.5"
                                  onClick={(_) => {
                                    const downloadLink = document.createElement(
                                      'a',
                                    );
                                    const fileName =
                                      doc?.documentFileNameWithExtension;
                                    downloadLink.href =
                                      doc?.documentBase64String;
                                    downloadLink.download = fileName;
                                    downloadLink.click();
                                  }}
                                  iconPre={
                                    <FontAwesomeIcon
                                      icon={faDownload}
                                    />
                                  }
                                >
                                  Download
                                </Button>
                              </Text>
                            </GridItem>
                          </Grid>
                        </Paper>
                      </div>
                    );
                  },
                )
              ) : (
                <div></div>
              ),
          },
        ].filter((d) => d),
      },
      buyFirePolicy?.proposalNumber?.length === 0
        ? {
            grid_data: [
              ...(values?.documentDetails &&
              values?.documentDetails?.length > 0
                ? values?.documentDetails?.map((_, idx) => {
                    return {
                      type: 'render',
                      colSpan: repeat,
                      component: () => {
                        return (
                          <Paper
                            className={`bg-white shadow-md rounded border border-neutral p-4 flex flex-${
                              screenType
                                ?.toString()
                                ?.toLowerCase() === 'mobile'
                                ? 'col space-y-6'
                                : 'row space-x-6'
                            }`}
                          >
                            <Text
                              className={
                                screenType
                                  ?.toString()
                                  ?.toLowerCase() === 'mobile'
                                  ? 'w-full'
                                  : 'flex flex-col w-1/3'
                              }
                            >
                              <Text>
                                <QuantaSelect
                                  name={`documentDetails[${idx}].documentName`}
                                  size={'full'}
                                  disabled={!clickEnabled}
                                  label={
                                    <Text type={'label'}>
                                      Document Type{' '}
                                      <Text severity={'error'}></Text>
                                    </Text>
                                  }
                                  onDataChange={(val, _) => {
                                    setFieldValue(
                                      `documentDetails[${idx}].documentNameValue`,
                                      documentList?.find(
                                        (document) =>
                                          document?.code
                                            ?.toString()
                                            ?.toLowerCase() ===
                                          val
                                            ?.toString()
                                            ?.toLowerCase(),
                                      )?.value,
                                    );
                                  }}
                                  data={
                                    documentList &&
                                    documentList?.length > 0
                                      ? documentList?.map(
                                          (document) => {
                                            return {
                                              label: document?.value
                                                ? `${document?.value}`
                                                : '',
                                              value: document?.code
                                                ? `${document?.code}`
                                                : '',
                                            };
                                          },
                                        )
                                      : []
                                  }
                                />
                              </Text>
                              <Text>
                                <QuantaInput
                                  name={`documentDetails[${idx}].documentDescription`}
                                  size={'full'}
                                  label={
                                    <Text type={'label'}>
                                      Description{' '}
                                      <Text severity={'error'}>
                                        {values?.documentDetails[
                                          idx
                                        ]?.documentNameValue
                                          ?.toString()
                                          ?.toLowerCase()
                                          ?.trim() === 'others'
                                          ? '*'
                                          : ''}
                                      </Text>
                                    </Text>
                                  }
                                  disabled={!clickEnabled}
                                  placeholder={
                                    'Type description if others'
                                  }
                                  onKeyDown={(evt) => {
                                    if (
                                      (evt?.target?.value
                                        ?.toString()
                                        ?.endsWith(' ') &&
                                        evt?.key === ' ') ||
                                      (evt?.target?.value?.toString()
                                        ?.length === 0 &&
                                        evt?.key === ' ')
                                    ) {
                                      evt.preventDefault();
                                    }
                                  }}
                                />
                              </Text>
                            </Text>
                            <span
                              onDragEnter={(evt) => {
                                evt.preventDefault();
                                evt.stopPropagation();
                                if (
                                  values?.documentDetails[idx]
                                    ?.documentName &&
                                  clickEnabled
                                ) {
                                  setFieldValue(
                                    `documentDetails[${idx}].dragCounter`,
                                    values?.documentDetails[idx]
                                      ?.dragCounter + 1,
                                  );
                                  if (
                                    evt?.dataTransfer?.items?.length >
                                    0
                                  ) {
                                    setFieldValue(
                                      `documentDetails[${idx}].dragging`,
                                      true,
                                    );
                                  }
                                }
                              }}
                              onDragLeave={(evt) => {
                                evt.preventDefault();
                                evt.stopPropagation();
                                if (
                                  values?.documentDetails[idx]
                                    ?.documentName &&
                                  clickEnabled
                                ) {
                                  if (
                                    values?.documentDetails[idx]
                                      ?.dragCounter === 1
                                  ) {
                                    setFieldValue(
                                      `documentDetails[${idx}].dragging`,
                                      false,
                                    );
                                  }
                                  setFieldValue(
                                    `documentDetails[${idx}].dragCounter`,
                                    values?.documentDetails[idx]
                                      ?.dragCounter - 1,
                                  );
                                }
                              }}
                              onDragOver={(evt) => {
                                evt.preventDefault();
                                evt.stopPropagation();
                              }}
                              onDrop={(evt) => {
                                evt.preventDefault();
                                evt.stopPropagation();
                                if (
                                  values?.documentDetails[idx]
                                    ?.documentName &&
                                  evt?.dataTransfer?.files?.length >
                                    0 &&
                                  clickEnabled
                                ) {
                                  if (
                                    documentExtensions?.find(
                                      (extension) =>
                                        extension?.value
                                          ?.toString()
                                          ?.toLowerCase() ===
                                        evt?.dataTransfer?.files[0]?.name
                                          ?.split('.')
                                          .pop()
                                          ?.toString()
                                          ?.toLowerCase(),
                                    )
                                  ) {
                                    let reader = new FileReader();
                                    const file =
                                      evt?.dataTransfer?.files[0];
                                    if (
                                      file?.size / 1024 <=
                                      parseFloat(
                                        docFileSizeLimit?.code,
                                      )
                                    ) {
                                      setFieldValue(
                                        `documentDetails[${idx}].documentExtension`,
                                        documentExtensions?.find(
                                          (extension) =>
                                            extension?.value
                                              ?.toString()
                                              ?.toLowerCase() ===
                                            file?.name
                                              ?.split('.')
                                              .pop()
                                              ?.toString()
                                              ?.toLowerCase(),
                                        )?.code,
                                      );
                                      setFieldValue(
                                        `documentDetails[${idx}].documentSize`,
                                        parseFloat(
                                          parseFloat(
                                            file?.size / 1024,
                                          )?.toFixed(2),
                                        ),
                                      );
                                      setFieldValue(
                                        `documentDetails[${idx}].documentSizeinKB`,
                                        `${parseFloat(
                                          parseFloat(
                                            file?.size / 1024,
                                          )?.toFixed(2),
                                        )} Kb`,
                                      );
                                      setFieldValue(
                                        `documentDetails[${idx}].documentFileName`,
                                        file?.name?.split('.')[0],
                                      );
                                      setFieldValue(
                                        `documentDetails[${idx}].documentFileNameWithExtension`,
                                        file?.name,
                                      );
                                      reader.readAsDataURL(file);
                                      reader.onload = () => {
                                        setFieldValue(
                                          `documentDetails[${idx}].documentBase64String`,
                                          reader.result,
                                        );
                                      };
                                      //evt.dataTransfer.clearData();
                                      setFieldValue(
                                        `documentDetails[${idx}].dragCounter`,
                                        0,
                                      );
                                      setFieldValue(
                                        `documentDetails[${idx}].dragging`,
                                        false,
                                      );
                                      uploadDocRef.current = [
                                        ...uploadDocRef?.current?.filter(
                                          (ref) =>
                                            parseInt(
                                              ref?.id?.toString(),
                                            ) !== idx,
                                        ),
                                      ];
                                    } else {
                                      setParentAlerts([
                                        {
                                          id: Date.now(),
                                          header:
                                            'Error fetching document',
                                          content: (
                                            <Text>
                                              File size is larger than{' '}
                                              {
                                                docFileSizeLimit?.value
                                              }
                                            </Text>
                                          ),
                                          type: 'error',
                                          timeout: 4000,
                                          disableClose: false,
                                        },
                                      ]);
                                      setFieldValue(
                                        `documentDetails[${idx}].dragCounter`,
                                        0,
                                      );
                                      setFieldValue(
                                        `documentDetails[${idx}].dragging`,
                                        false,
                                      );
                                      uploadDocRef.current = [];
                                    }
                                  } else {
                                    //evt.dataTransfer.clearData();
                                    setFieldValue(
                                      `documentDetails[${idx}].dragCounter`,
                                      0,
                                    );
                                    setFieldValue(
                                      `documentDetails[${idx}].dragging`,
                                      false,
                                    );
                                    setParentAlerts([
                                      {
                                        id: Date.now(),
                                        content: (
                                          <Text>
                                            Input file Format is not
                                            supported
                                          </Text>
                                        ),
                                        type: 'error',
                                        disableClose: false,
                                        timeout: 4000,
                                      },
                                      ...alerts,
                                    ]);
                                    uploadDocRef.current = [
                                      ...uploadDocRef?.current?.filter(
                                        (ref) =>
                                          parseInt(
                                            ref?.id?.toString(),
                                          ) !== idx,
                                      ),
                                    ];
                                  }
                                }
                              }}
                              className={`w-full my-1 border-2 border-dotted border-secondary justify-center flex flex-col ${
                                screenType
                                  ?.toString()
                                  ?.toLowerCase() === 'mobile'
                                  ? 'flex-wrap'
                                  : ''
                              } p-4`}
                            >
                              <Text
                                className={
                                  values?.documentDetails[idx]
                                    ?.dragging
                                    ? 'text-2xl text-neutral-darker flex justify-center'
                                    : ''
                                }
                              >
                                {values?.documentDetails[idx]
                                  ?.dragging ? (
                                  'Drop here'
                                ) : values?.documentDetails[idx]
                                    ?.documentFileName ? (
                                  <Text className={'flex flex-col'}>
                                    <Text
                                      className={'flex flex-wrap'}
                                    >
                                      <Text>File Name:&nbsp;</Text>
                                      <Text
                                        severity={'info'}
                                        className={
                                          'font-semibold break-normal'
                                        }
                                      >{`${
                                        values?.documentDetails[idx]
                                          ?.documentFileName
                                      }.${
                                        documentExtensions?.find(
                                          (extension) =>
                                            extension?.code
                                              ?.toString()
                                              ?.toLowerCase() ===
                                            values?.documentDetails[
                                              idx
                                            ]?.documentExtension
                                              ?.toString()
                                              ?.toLowerCase(),
                                        )?.value
                                      }`}</Text>
                                    </Text>
                                    <Text>
                                      File Size:&nbsp;
                                      <Text
                                        className={'font-semibold'}
                                      >
                                        {`${values?.documentDetails[idx]?.documentSize}`}{' '}
                                        KB
                                      </Text>
                                    </Text>
                                  </Text>
                                ) : (
                                  `${
                                    screenType
                                      ?.toString()
                                      ?.toLowerCase() !== 'desktop'
                                      ? 'Click the browse button to select a file'
                                      : `Drag and drop your document here to
                                upload. Alternatively you can browse
                                the file by clicking the button`
                                  }`
                                )}
                              </Text>
                              {!values?.documentDetails[idx]
                                ?.dragging &&
                              !values?.documentDetails[idx]
                                ?.documentFileName ? (
                                <Text
                                  className={`flex ${
                                    screenType
                                      ?.toString()
                                      ?.toLowerCase() === 'mobile'
                                      ? 'flex-col space-y-2'
                                      : 'space-x-2'
                                  } justify-end ${
                                    screenType
                                      ?.toString()
                                      ?.toLowerCase() === 'mobile'
                                      ? 'w-full mt-4'
                                      : ''
                                  }`}
                                >
                                  {values?.documentDetails?.length >
                                    1 && (
                                    <Text>
                                      <Button
                                        size={'small'}
                                        flat={true}
                                        className={`h-10 w-24 w-${
                                          screenType
                                            ?.toString()
                                            ?.toLowerCase() ===
                                          'mobile'
                                            ? 'full'
                                            : '24'
                                        }`}
                                        disabled={!clickEnabled}
                                        onClick={(_) => {
                                          if (
                                            values?.documentDetails
                                              ?.length > 1
                                          ) {
                                            setFieldValue(
                                              `documentDetails`,
                                              [
                                                ...values?.documentDetails?.slice(
                                                  0,
                                                  idx,
                                                ),
                                                ...values?.documentDetails?.slice(
                                                  idx + 1,
                                                ),
                                              ],
                                            );
                                            uploadDocRef.current = [
                                              ...uploadDocRef?.current?.filter(
                                                (ref) =>
                                                  parseInt(
                                                    ref?.id?.toString(),
                                                  ) !== idx,
                                              ),
                                            ];
                                          }
                                        }}
                                      >
                                        Cancel
                                      </Button>
                                    </Text>
                                  )}
                                  <Text>
                                    <Button
                                      size={'small'}
                                      type={'button'}
                                      flat={false}
                                      className={`h-10 w-24 w-${
                                        screenType
                                          ?.toString()
                                          ?.toLowerCase() === 'mobile'
                                          ? 'full'
                                          : '24'
                                      }`}
                                      disabled={
                                        !clickEnabled ||
                                        !values?.documentDetails[idx]
                                          ?.documentName
                                          ? true
                                          : false
                                      }
                                      onClick={(_) => {
                                        uploadDocRef?.current
                                          ?.find(
                                            (ref) =>
                                              parseInt(
                                                ref?.id?.toString(),
                                              ) === idx,
                                          )
                                          ?.click();
                                      }}
                                    >
                                      Browse
                                      <input
                                        key={idx}
                                        id={idx}
                                        ref={(ref) => {
                                          if (
                                            !uploadDocRef?.current?.find(
                                              (r) =>
                                                r?.id === ref?.id,
                                            ) &&
                                            ref
                                          ) {
                                            uploadDocRef?.current?.push(
                                              ref,
                                            );
                                          }
                                        }}
                                        className="hidden"
                                        type="file"
                                        accept={`${documentExtensions
                                          ?.map(
                                            (extension) =>
                                              `.${extension?.value}`,
                                          )
                                          ?.join(',')}`}
                                        disabled={
                                          !clickEnabled ||
                                          !values?.documentDetails[
                                            idx
                                          ]?.documentName
                                            ? true
                                            : false
                                        }
                                        onChange={(evt) => {
                                          if (
                                            evt?.target?.files
                                              ?.length > 0
                                          ) {
                                            let reader = new FileReader();
                                            const file =
                                              evt?.target?.files[0];
                                            if (
                                              file?.size / 1024 <=
                                              parseFloat(
                                                docFileSizeLimit?.code,
                                              )
                                            ) {
                                              setFieldValue(
                                                `documentDetails[${idx}].documentExtension`,
                                                documentExtensions?.find(
                                                  (extension) =>
                                                    extension?.value
                                                      ?.toString()
                                                      ?.toLowerCase() ===
                                                    file?.name
                                                      ?.split('.')
                                                      .pop()
                                                      ?.toString()
                                                      ?.toLowerCase(),
                                                )?.code,
                                              );
                                              setFieldValue(
                                                `documentDetails[${idx}].documentSize`,
                                                parseFloat(
                                                  parseFloat(
                                                    file?.size / 1024,
                                                  )?.toFixed(2),
                                                ),
                                              );
                                              setFieldValue(
                                                `documentDetails[${idx}].documentSizeinKB`,
                                                `${parseFloat(
                                                  parseFloat(
                                                    file?.size / 1024,
                                                  )?.toFixed(2),
                                                )} Kb`,
                                              );
                                              setFieldValue(
                                                `documentDetails[${idx}].documentFileName`,
                                                file?.name?.split(
                                                  '.',
                                                )[0],
                                              );
                                              setFieldValue(
                                                `documentDetails[${idx}].documentFileNameWithExtension`,
                                                file?.name,
                                              );
                                              reader.readAsDataURL(
                                                file,
                                              );
                                              reader.onload = () => {
                                                setFieldValue(
                                                  `documentDetails[${idx}].documentBase64String`,
                                                  reader.result,
                                                );
                                              };
                                              setFieldValue(
                                                `documentDetails[${idx}].dragCounter`,
                                                0,
                                              );
                                              uploadDocRef.current = [
                                                ...uploadDocRef?.current?.filter(
                                                  (ref) =>
                                                    parseInt(
                                                      ref?.id?.toString(),
                                                    ) !== idx,
                                                ),
                                              ];
                                            } else {
                                              setParentAlerts([
                                                {
                                                  id: Date.now(),
                                                  header:
                                                    'Error fetching document',
                                                  content: (
                                                    <Text>
                                                      File size is
                                                      larger than{' '}
                                                      {
                                                        docFileSizeLimit?.value
                                                      }
                                                    </Text>
                                                  ),
                                                  type: 'error',
                                                  timeout: 4000,
                                                  disableClose: false,
                                                },
                                              ]);
                                              uploadDocRef.current = [];
                                            }
                                          }
                                          evt.target.value = '';
                                        }}
                                      />
                                    </Button>
                                  </Text>
                                </Text>
                              ) : values?.documentDetails[idx]
                                  ?.documentFileName &&
                                !values?.documentDetails[idx]
                                  ?.dragging ? (
                                <Text
                                  className={
                                    screenType
                                      ?.toString()
                                      ?.toLowerCase() === 'mobile'
                                      ? 'w-full mt-4'
                                      : ''
                                  }
                                  severity={
                                    clickEnabled
                                      ? 'action'
                                      : 'neutral-darker'
                                  }
                                >
                                  <Text
                                    className={`flex ${
                                      screenType
                                        ?.toString()
                                        ?.toLowerCase() === 'mobile'
                                        ? 'flex-col space-y-2'
                                        : 'space-x-2'
                                    } justify-end ${
                                      screenType
                                        ?.toString()
                                        ?.toLowerCase() === 'mobile'
                                        ? 'w-full mt-4'
                                        : ''
                                    }`}
                                  >
                                    {values?.documentDetails?.length >
                                      1 && (
                                      <Text>
                                        <Button
                                          size={'small'}
                                          flat={true}
                                          className={`h-10 w-24 w-${
                                            screenType
                                              ?.toString()
                                              ?.toLowerCase() ===
                                            'mobile'
                                              ? 'full'
                                              : '24'
                                          }`}
                                          disabled={!clickEnabled}
                                          onClick={(_) => {
                                            if (
                                              values?.documentDetails
                                                ?.length > 1
                                            ) {
                                              setFieldValue(
                                                `documentDetails`,
                                                [
                                                  ...values?.documentDetails?.slice(
                                                    0,
                                                    idx,
                                                  ),
                                                  ...values?.documentDetails?.slice(
                                                    idx + 1,
                                                  ),
                                                ],
                                              );
                                              uploadDocRef.current = [
                                                ...uploadDocRef?.current?.filter(
                                                  (ref) =>
                                                    parseInt(
                                                      ref?.id?.toString(),
                                                    ) !== idx,
                                                ),
                                              ];
                                            }
                                          }}
                                        >
                                          Cancel
                                        </Button>
                                      </Text>
                                    )}
                                    <Text>
                                      <Button
                                        disabled={!clickEnabled}
                                        size={'small'}
                                        flat={true}
                                        className={`h-10 w-24 w-${
                                          screenType
                                            ?.toString()
                                            ?.toLowerCase() ===
                                          'mobile'
                                            ? 'full'
                                            : '24'
                                        }`}
                                        onClick={(_) => {
                                          setFieldValue(
                                            `documentDetails[${idx}].documentFileName`,
                                            '',
                                          );
                                          setFieldValue(
                                            `documentDetails[${idx}].documentFileNameWithExtension`,
                                            '',
                                          );
                                          setFieldValue(
                                            `documentDetails[${idx}].documentExtension`,
                                            '',
                                          );
                                          setFieldValue(
                                            `documentDetails[${idx}].documentSize`,
                                            null,
                                          );
                                          setFieldValue(
                                            `documentDetails[${idx}].documentSizeinKB`,
                                            '',
                                          );
                                          setFieldValue(
                                            `documentDetails[${idx}].dragging`,
                                            false,
                                          );
                                          setFieldValue(
                                            `documentDetails[${idx}].dragCounter`,
                                            0,
                                          );
                                          setFieldValue(
                                            `documentDetails[${idx}].documentBase64String`,
                                            '',
                                          );
                                        }}
                                      >
                                        Delete
                                      </Button>
                                    </Text>
                                  </Text>
                                </Text>
                              ) : null}
                            </span>
                          </Paper>
                        );
                      },
                    };
                  })
                : []),
              {
                type: 'render',
                colSpan: repeat,
                component: () => {
                  return (
                    <Text
                      className={'flex flex-col w-full space-y-2'}
                    >
                      <Text>
                        <Button
                          flat={true}
                          size={'small'}
                          className={
                            screenType?.toString()?.toLowerCase() ===
                            'mobile'
                              ? 'w-full h-10'
                              : 'h-10'
                          }
                          disabled={!clickEnabled}
                          onClick={(_) => {
                            setFieldValue('documentDetails', [
                              ...values?.documentDetails,
                              {
                                documentDescription: '',
                                documentName: '',
                                documentNameValue: '',
                                documentFileName: '',
                                documentFileNameWithExtension: '',
                                documentExtension: '',
                                documentSize: null,
                                documentSizeinKB: '',
                                dragging: false,
                                dragCounter: 0,
                                documentBase64String: '',
                              },
                            ]);
                          }}
                        >
                          Add More Document
                        </Button>
                      </Text>
                    </Text>
                  );
                },
              },
            ].filter((d) => d),
          }
        : {
            grid_type: 'data',
            grid_data: [
              {
                label: '',
                colSpan: repeat,
                text:
                  buyFirePolicy?.reviewAndConfirmTabDetails
                    ?.documentDetails &&
                  buyFirePolicy?.reviewAndConfirmTabDetails
                    ?.documentDetails?.length > 0 &&
                  buyFirePolicy?.reviewAndConfirmTabDetails?.documentDetails?.filter(
                    (docDet) =>
                      docDet?.documentName &&
                      docDet?.documentBase64String,
                  )?.length > 0 ? (
                    buyFirePolicy?.reviewAndConfirmTabDetails?.documentDetails?.map(
                      (doc, idx) => {
                        return (
                          <Paper
                            key={idx}
                            className={`my-4 ${
                              idx === 0 ? '-mt-1' : ''
                            } bg-white border border-neutral p-4 rounded`}
                          >
                            <Grid
                              repeat={repeat}
                              gap={0}
                              gapX={0}
                              gapY={0}
                            >
                              <GridItem
                                colSpan={
                                  screenType
                                    ?.toString()
                                    ?.toLowerCase() === 'mobile'
                                    ? 1
                                    : 2
                                }
                              >
                                <Text>
                                  <Text>
                                    <FontAwesomeIcon
                                      icon={faPaperclip}
                                      size="1x"
                                      className="mr-3"
                                    />
                                  </Text>
                                  <Text
                                    severity={'info'}
                                    className={'font-semibold'}
                                  >
                                    {doc?.documentDescription &&
                                    doc?.documentName
                                      ?.toString()
                                      ?.toLowerCase() === 'others'
                                      ? doc?.documentDescription
                                      : doc?.documentName}
                                  </Text>
                                  <Text
                                    className={'flex flex-col ml-7'}
                                    severity={'neutral-darker'}
                                    type={'label'}
                                  >
                                    <Text
                                      className={
                                        'flex items-center flex-wrap'
                                      }
                                    >
                                      <Text type={'label'}>
                                        File Name:&nbsp;
                                      </Text>
                                      <Text
                                        type={'label'}
                                        className={'break-normal'}
                                      >
                                        {
                                          doc?.documentFileNameWithExtension
                                        }
                                      </Text>
                                    </Text>
                                  </Text>
                                  <Text
                                    className={'flex flex-col ml-7'}
                                    severity={'neutral-darker'}
                                    type={'label'}
                                  >
                                    File Size:&nbsp;
                                    {doc?.documentSize} KB
                                  </Text>
                                </Text>
                              </GridItem>
                              <GridItem
                                colSpan={
                                  screenType
                                    ?.toString()
                                    ?.toLowerCase() === 'mobile'
                                    ? repeat
                                    : 1
                                }
                                className={
                                  'flex flex-col justify-center items-center'
                                }
                              >
                                <Text className="flex justify-center items-center">
                                  <Button
                                    type={'button'}
                                    flat={true}
                                    className="w-full md:w-56 md:pr-4 max-h-10 -ml-0.5"
                                    onClick={(_) => {
                                      const downloadLink = document.createElement(
                                        'a',
                                      );
                                      const fileName =
                                        doc?.documentFileNameWithExtension;
                                      downloadLink.href =
                                        doc?.documentBase64String;
                                      downloadLink.download = fileName;
                                      downloadLink.click();
                                    }}
                                    iconPre={
                                      <FontAwesomeIcon
                                        icon={faDownload}
                                      />
                                    }
                                  >
                                    Download
                                  </Button>
                                </Text>
                              </GridItem>
                            </Grid>
                          </Paper>
                        );
                      },
                    )
                  ) : (
                    <div></div>
                  ),
              },
            ].filter((d) => d),
          },
      buyFirePolicy?.proposalNumber?.length > 0
        ? {
            grid_type: 'data',
            grid_data: [
              {
                label: '',
                colSpan: repeat,
                text:
                  buyFirePolicy?.quoteData?.documentDetails?.filter(
                    (docDet) =>
                      docDet?.documentName &&
                      docDet?.documentBase64String,
                  )?.length === 0 &&
                  buyFirePolicy?.reviewAndConfirmTabDetails?.documentDetails?.filter(
                    (docDet) =>
                      docDet?.documentName &&
                      docDet?.documentBase64String,
                  )?.length === 0 ? (
                    <Text></Text>
                  ) : (
                    <Text
                      severity={'neutral'}
                      className="text-2xl flex justify-center items-center -mt-16"
                    >
                      No Documents Uploaded
                    </Text>
                  ),
              },
            ].filter((d) => d),
          }
        : null,
    ].filter((d) => d);

    const clausesDetailsData = [
      {
        grid_data: [
          getDefaultClauses && getDefaultClauses?.length > 0
            ? {
                type: 'render',
                colSpan: repeat,
                component: () => {
                  return (
                    <Text type="title" className="font-semibold">
                      <Text type="title" className="ml-1 mt-3">
                        Default Clauses
                      </Text>
                      <ul className="list-disc ml-6 mt-4 font-normal">
                        {getDefaultClauses?.map((clause, idx) => (
                          <li key={idx}>
                            {clause?.clauseDescription}
                          </li>
                        ))}
                      </ul>
                    </Text>
                  );
                },
              }
            : null,
          buyFirePolicy &&
          buyFirePolicy?.quoteData &&
          buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
            ?.clauses?.userDefinedClauses &&
          buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
            ?.clauses?.userDefinedClauses?.length > 0
            ? {
                type: 'render',
                colSpan: repeat,
                component: () => {
                  return (
                    <Text type="title" className="font-semibold">
                      <Text type="title" className="ml-1 mt-3">
                        User Defined Clauses
                      </Text>
                      <ul className="list-disc ml-6 mt-4 font-normal">
                        {buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails?.clauses?.userDefinedClauses?.map(
                          (clause, idx) => (
                            <li key={idx}>{clause}</li>
                          ),
                        )}
                      </ul>
                    </Text>
                  );
                },
              }
            : null,
          getDefaultClauses?.length === 0 &&
          buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
            ?.clauses?.userDefinedClauses?.length === 0
            ? {
                type: 'render',
                colSpan: repeat,
                component: () => {
                  return (
                    <Text type="normal" className="font-semibold">
                      <Text type="normal" className="ml-1 mt-3">
                        No Clauses Available
                      </Text>
                    </Text>
                  );
                },
              }
            : null,
        ].filter((d) => d),
      },
    ].filter((d) => d);

    const conditionDetailsData = [
      {
        grid_data: [
          getDefaultConditions && getDefaultConditions?.length > 0
            ? {
                type: 'render',
                colSpan: repeat,
                component: () => {
                  return (
                    <Text type="title" className="font-semibold">
                      <Text type="title" className="ml-1 mt-3">
                        Default Conditions
                      </Text>
                      <ul className="list-disc ml-6 mt-4 font-normal">
                        {getDefaultConditions?.map(
                          (condition, idx) => (
                            <li key={idx}>
                              {condition?.conditionShortDescription}
                            </li>
                          ),
                        )}
                      </ul>
                    </Text>
                  );
                },
              }
            : null,
          buyFirePolicy &&
          buyFirePolicy?.quoteData &&
          buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
            ?.conditions?.userDefinedConditions &&
          buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
            ?.conditions?.userDefinedConditions?.length > 0
            ? {
                type: 'render',
                colSpan: repeat,
                component: () => {
                  return (
                    <Text type="title" className="font-semibold">
                      <Text type="title" className="ml-1 mt-3">
                        User Defined Conditions
                      </Text>
                      <ul className="list-disc ml-6 mt-4 font-normal">
                        {buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails?.conditions?.userDefinedConditions?.map(
                          (condition, idx) => (
                            <li key={idx}>{condition}</li>
                          ),
                        )}
                      </ul>
                    </Text>
                  );
                },
              }
            : null,
          getDefaultConditions?.length === 0 &&
          buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
            ?.conditions?.userDefinedConditions?.length === 0
            ? {
                type: 'render',
                colSpan: repeat,
                component: () => {
                  return (
                    <Text type="normal" className="font-semibold">
                      <Text type="normal" className="ml-1 mt-3">
                        No Conditions Available
                      </Text>
                    </Text>
                  );
                },
              }
            : null,
        ].filter((d) => d),
      },
    ].filter((d) => d);

    const exclusionDetailsData = [
      {
        grid_data: [
          getDefaultExclusions && getDefaultExclusions?.length > 0
            ? {
                type: 'render',
                colSpan: repeat,
                component: () => {
                  return (
                    <Text type="title" className="font-semibold">
                      <Text type="title" className="ml-1 mt-3">
                        Default Exclusions
                      </Text>
                      <ul className="list-disc ml-6 mt-4 font-normal">
                        {getDefaultExclusions?.map(
                          (exclusion, idx) => (
                            <li key={idx}>
                              {exclusion?.exclusionShortDescription}
                            </li>
                          ),
                        )}
                      </ul>
                    </Text>
                  );
                },
              }
            : null,
          buyFirePolicy &&
          buyFirePolicy?.quoteData &&
          buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
            ?.exclusions?.userDefinedExclusions &&
          buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
            ?.exclusions?.userDefinedExclusions?.length > 0
            ? {
                type: 'render',
                colSpan: repeat,
                component: () => {
                  return (
                    <Text type="title" className="font-semibold">
                      <Text type="title" className="ml-1 mt-3">
                        User Defined Exclusions
                      </Text>
                      <ul className="list-disc ml-6 mt-4 font-normal">
                        {buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails?.exclusions?.userDefinedExclusions?.map(
                          (exclusion, idx) => (
                            <li key={idx}>{exclusion}</li>
                          ),
                        )}
                      </ul>
                    </Text>
                  );
                },
              }
            : null,
          getDefaultExclusions?.length === 0 &&
          buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
            ?.exclusions?.userDefinedExclusions?.length === 0
            ? {
                type: 'render',
                colSpan: repeat,
                component: () => {
                  return (
                    <Text type="normal" className="font-semibold">
                      <Text type="normal" className="ml-1 mt-3">
                        No Exclusions Available
                      </Text>
                    </Text>
                  );
                },
              }
            : null,
        ].filter((d) => d),
      },
    ].filter((d) => d);
    const nomineeDetailsData = [
      {
        grid_type: 'data',
        grid_data: [
          {
            label: 'Cost Of Construction',
            text: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.costOfConstruction,
          },
          {
            label: 'Carpet Area(In Sq Ft)',
            text: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.carpetArea,
          },
          {
            label: 'Additional Structure',
            text: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.additionalStructure,
          },
          {
            label: 'Total Building SI',
            text: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.totalBuildingSI,
          },
          buyFirePolicy?.policyTypeValue
          ?.toString() !== 'Home Contents Only' ? 
          {

            label: 'General Content SI',

            text: ( buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.additionalContentSI)
            ? 
              (parseInt(buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.generalContentSI)+
              parseInt(buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.additionalContentSI))
            :  
            buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.generalContentSI ||
            buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.GeneralContentSI,

          }
          : {
            label: 'General Content SI',
            text: ( buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.additionalContentSI)
            ? parseInt(buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.additionalContentSI)
            : buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.generalContentSI ||
            buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.GeneralContentSI,

          },
          {
            label: 'Valuable Content SI',
            text: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.valuableContentSI
            || buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.ValuableContentSI,
          },
          {
            label: 'Total Content SI',
            text: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.totalContentSI
            || buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.TotalContentSI,
          },            
        ].filter((d) => d),
      },
     ];
    const warrantyDetailsData = [
      {
        grid_data: [
          getDefaultWarranties && getDefaultWarranties?.length > 0
            ? {
                type: 'render',
                colSpan: repeat,
                component: () => {
                  return (
                    <Text type="title" className="font-semibold">
                      <Text type="title" className="ml-1 mt-3">
                        Default Warranties
                      </Text>
                      <ul className="list-disc ml-6 mt-4 font-normal">
                        {getDefaultWarranties?.map(
                          (warranty, idx) => (
                            <li key={idx}>
                              {warranty?.warrantyShortDescription}
                            </li>
                          ),
                        )}
                      </ul>
                    </Text>
                  );
                },
              }
            : null,
          buyFirePolicy &&
          buyFirePolicy?.quoteData &&
          buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
            ?.warranties?.userDefinedWarranties &&
          buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
            ?.warranties?.userDefinedWarranties?.length > 0
            ? {
                type: 'render',
                colSpan: repeat,
                component: () => {
                  return (
                    <Text type="title" className="font-semibold">
                      <Text type="title" className="ml-1 mt-3">
                        User Defined Warranties
                      </Text>
                      <ul className="list-disc ml-6 mt-4 font-normal">
                        {buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails?.warranties?.userDefinedWarranties?.map(
                          (warranty, idx) => (
                            <li key={idx}>{warranty}</li>
                          ),
                        )}
                      </ul>
                    </Text>
                  );
                },
              }
            : null,
          getDefaultWarranties?.length === 0 &&
          buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
            ?.warranties?.userDefinedWarranties?.length === 0
            ? {
                type: 'render',
                colSpan: repeat,
                component: () => {
                  return (
                    <Text type="normal" className="font-semibold">
                      <Text type="normal" className="ml-1 mt-3">
                        No Warranties Available
                      </Text>
                    </Text>
                  );
                },
              }
            : null,
        ].filter((d) => d),
      },
    ].filter((d) => d);

    const otherPropsTopSection = {
      flow: 'cols',
      repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      textType: 'normal',
      nullData: () => <Text severity="neutral">Not Captured</Text>,
    };

    const otherPropsForCards = {
      flow: 'cols',
      textType: 'normal',
      repeat: repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      titleType: 'normal',
      useExpandablePaper: false,
      useGlobalExpandablePaper: true,
      globalTitleSeverity: 'info',
      globalTitleType: 'large',
      nullData: () => <Text severity="neutral">Not Captured</Text>,
    };

    // const riskLocationDetailsData = [
    //   {
    //     label: 'Proposal Type',
    //     colSpan: 1,
    //     text: (
    //       <RiskDetailsData
    //         buyFirePolicy={buyFirePolicy}
    //         // goToStep
    //         productName={productName}
    //       />
    //     ),
    //   },
    // ];

    return (
      <QuantaForm className="space-y-4">
        <MixedGridGroup
          {...{ data: reviewAndConfirmData, ...otherPropsTopSection }}
        />

        <ProposerCustomerReadOnly
          reactiveVarData={buyFirePolicy}
          goToStep={goToStep}
          renderExpandedCards={renderExpandedCards}
        />

        {/* <MixedGridGroup
          {...{
            data: documentDetailsData,
            ...otherPropsForCards,
            globalTitle: 'Document Details',
            expanded: renderExpandedCards?.current?.find(
              (card) =>
                card?.cardName?.toString()?.toLowerCase() ===
                'document details',
            )?.flag,
            isToggleEnabled: true,
            setExpandedCards: (expanded) => {
              renderExpandedCards.current = [
                ...renderExpandedCards?.current?.filter(
                  (card) =>
                    card?.cardName?.toString()?.toLowerCase() !==
                    'document details',
                ),
                {
                  ...renderExpandedCards?.current?.find(
                    (card) =>
                      card?.cardName?.toString()?.toLowerCase() ===
                      'document details',
                  ),
                  flag: expanded,
                },
              ];
            },
          }}
        /> */}

        {/* <RiskDetailsData
          buyFirePolicy={buyFirePolicy}
          goToStep={goToStep}
          renderExpandedCards={renderExpandedCards}
        /> */}
        { <MixedGridGroup
          {...{
            data: nomineeDetailsData,
            ...otherPropsForCards,
            globalTitle: 'Risk sum Details',
          }}
        /> }
        {/* <MixedGridGroup
          {...{
            data: financierDetailsData,
            ...otherPropsForCards,
            globalTitle: 'Financier Details',
            expanded: renderExpandedCards?.current?.find(
              (card) =>
                card?.cardName?.toString()?.toLowerCase() ===
                'financier details',
            )?.flag,
            isToggleEnabled: true,
            setExpandedCards: (expanded) => {
              renderExpandedCards.current = [
                ...renderExpandedCards?.current?.filter(
                  (card) =>
                    card?.cardName?.toString()?.toLowerCase() !==
                    'financier details',
                ),
                {
                  ...renderExpandedCards?.current?.find(
                    (card) =>
                      card?.cardName?.toString()?.toLowerCase() ===
                      'financier details',
                  ),
                  flag: expanded,
                },
              ];
            },
          }}
        /> */}

        {/* <MixedGridGroup
          {...{
            data: clausesDetailsData,
            ...otherPropsForCards,
            globalTitle: 'Clauses',
            expanded: renderExpandedCards?.current?.find(
              (card) =>
                card?.cardName?.toString()?.toLowerCase() ===
                'clauses',
            )?.flag,
            isToggleEnabled: true,
            setExpandedCards: (expanded) => {
              renderExpandedCards.current = [
                ...renderExpandedCards?.current?.filter(
                  (card) =>
                    card?.cardName?.toString()?.toLowerCase() !==
                    'clauses',
                ),
                {
                  ...renderExpandedCards?.current?.find(
                    (card) =>
                      card?.cardName?.toString()?.toLowerCase() ===
                      'clauses',
                  ),
                  flag: expanded,
                },
              ];
            },
          }}
        /> */}

        {/* <MixedGridGroup
          {...{
            data: conditionDetailsData,
            ...otherPropsForCards,
            globalTitle: 'Conditions',
            expanded: renderExpandedCards?.current?.find(
              (card) =>
                card?.cardName?.toString()?.toLowerCase() ===
                'conditions',
            )?.flag,
            isToggleEnabled: true,
            setExpandedCards: (expanded) => {
              renderExpandedCards.current = [
                ...renderExpandedCards?.current?.filter(
                  (card) =>
                    card?.cardName?.toString()?.toLowerCase() !==
                    'conditions',
                ),
                {
                  ...renderExpandedCards?.current?.find(
                    (card) =>
                      card?.cardName?.toString()?.toLowerCase() ===
                      'conditions',
                  ),
                  flag: expanded,
                },
              ];
            },
          }}
        /> */}

        {/* <MixedGridGroup
          {...{
            data: exclusionDetailsData,
            ...otherPropsForCards,
            globalTitle: 'Exclusions',
            expanded: renderExpandedCards?.current?.find(
              (card) =>
                card?.cardName?.toString()?.toLowerCase() ===
                'exclusions',
            )?.flag,
            isToggleEnabled: true,
            setExpandedCards: (expanded) => {
              renderExpandedCards.current = [
                ...renderExpandedCards?.current?.filter(
                  (card) =>
                    card?.cardName?.toString()?.toLowerCase() !==
                    'exclusions',
                ),
                {
                  ...renderExpandedCards?.current?.find(
                    (card) =>
                      card?.cardName?.toString()?.toLowerCase() ===
                      'exclusions',
                  ),
                  flag: expanded,
                },
              ];
            },
          }}
        /> */}

        {/* <MixedGridGroup
          {...{
            data: warrantyDetailsData,
            ...otherPropsForCards,
            globalTitle: 'Warranties',
            expanded: renderExpandedCards?.current?.find(
              (card) =>
                card?.cardName?.toString()?.toLowerCase() ===
                'warranties',
            )?.flag,
            isToggleEnabled: true,
            setExpandedCards: (expanded) => {
              renderExpandedCards.current = [
                ...renderExpandedCards?.current?.filter(
                  (card) =>
                    card?.cardName?.toString()?.toLowerCase() !==
                    'warranties',
                ),
                {
                  ...renderExpandedCards?.current?.find(
                    (card) =>
                      card?.cardName?.toString()?.toLowerCase() ===
                      'warranties',
                  ),
                  flag: expanded,
                },
              ];
            },
          }}
        /> */}
      </QuantaForm>
    );
  };

  if (loadingDocumentExtensions) {
    return <Loading />;
  }

  if (errorDocumentExtensions) {
    return <Error error={errorDocumentExtensions} />;
  }

  const {
    documentExtensions,
    docFileSizeLimit,
    docDescCharacterLimit,
  } = dataDocumentExtensions;

  return (
    <QuantaFormik
      innerRef={props?.forwardedRef}
      enableReinitialize={true}
      {...{
        initialValues,
        validate,
        onSubmit,
        validator: () => ({}),
      }}
    >
      <ReviewAndConfirmForm
        {...{ validate, customerDocumentListAuto }}
      />
    </QuantaFormik>
  );
}
